// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function gallery1_viewportEnter(event, $w) {
	//Add your code for this event here: 
}

export function header1_click(event) {
	//Add your code for this event here: 
}

export function column2_dblClick(event) {
	//Add your code for this event here: 
}